/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { isHighDPI } from '@trello/browser';
import { makePreviewCachable } from '@trello/image-previews';
import { CardFrontTestIds } from '@trello/test-ids';

import { Util } from 'app/scripts/lib/util';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('card_in_list');

// eslint-disable-next-line @trello/no-module-logic
export const CardInListCoverTemplate = t.renderable(function ({
  cover,
  hasCover,
  hideCover,
  hasStickers,
  attachmentCoverUrl,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  let calculatedHeight;
  if (cover == null || hideCover || !hasCover) {
    return t.div('.list-card-cover.js-card-cover', {
      'data-testid': CardFrontTestIds.CardCover,
    });
  }

  const {
    idAttachment,
    idUploadedBackground,
    color,
    scaled,
    edgeColor,
    size,
    idPlugin,
  } = cover;

  if (size === 'full') {
    return t.div('.list-card-cover.js-card-cover');
  }

  if (color) {
    calculatedHeight = hasStickers ? 64 : 32;

    return t.div(
      `.list-card-cover.js-card-cover.color-card-cover.color-card-cover-${color}.color-blind-pattern-${color}.is-covered`,
      {
        'data-testid': CardFrontTestIds.CardCover, //only adding here because the Playwright test only currently covers the color version
        style: t.stylify({
          height: `${calculatedHeight}px`,
        }),
      },
    );
  } else if (idAttachment || idUploadedBackground || idPlugin) {
    let left;
    const minWidth = isHighDPI() ? 600 : 300;
    let preview =
      (left = Util.smallestPreviewBiggerThan(scaled, minWidth)) != null
        ? left
        : Util.biggestPreview(scaled);

    // Not sure how this can happen but supporting it anyway just in case it's a legacy thing.
    if (preview == null && idAttachment) {
      // @ts-expect-error TS(2739): Type '{ url: any; }' is missing the following prop... Remove this comment to see the full error message
      preview = { url: attachmentCoverUrl };
    }

    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const maxHeight = Math.min(preview.height, 260); // An arbitrarily chosen number
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    calculatedHeight = (preview.height * 245) / preview.width;

    return t.div('.list-card-cover.js-card-cover.is-covered', {
      style: t.stylify({
        height: `${
          calculatedHeight < maxHeight ? calculatedHeight : maxHeight
        }px`,
        'background-color': edgeColor != null ? edgeColor : 'transparent',
        // @ts-expect-error TS(2531): Object is possibly 'null'.
        'background-image': `url("${makePreviewCachable(preview.url)}")`,
        'background-size': calculatedHeight <= maxHeight ? 'cover' : 'contain',
      }),
    });
  }
});
